/* eslint-disable @typescript-eslint/no-explicit-any */
// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";
import { supabaseStorage } from "@/lib/platformStorage";

declare global {
  // Allow Playwright tests to inject a mock Supabase client via window.supabase
  interface Window {
    supabase?: any;
  }
}

// Use environment variables - these MUST be set via .env files or CI/CD
// No hardcoded fallbacks to ensure environment-specific configuration
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  throw new Error(
    "Missing Supabase configuration. Please ensure VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are set in your environment."
  );
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Prefer a test-provided mock if available (set in Playwright via addInitScript)
const injected =
  typeof window !== "undefined" ? (window as any).supabase : undefined;

export const supabase =
  injected ??
  createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
    auth: {
      storage: supabaseStorage,
      persistSession: true,
      autoRefreshToken: true,
    },
    realtime: {
      params: {
        eventsPerSecond: 10,
      },
      heartbeatIntervalMs: 30000,
      reconnectAfterMs: (tries: number) => Math.min(tries * 1000, 30000),
    },
    global: {
      headers: {
        "X-Client-Info": "HealJou",
      },
    },
  });
